import RestService from '../services/rest';

async function getBanners(limit, skip, search, order = '', field = '') {
  return RestService.getAuthenticated(
    `panel/banners?limit=${limit}&skip=${skip}&search=${search}&order=${order}&field=${field}`,
  );
}

async function getBanner(id) {
  return RestService.getAuthenticated(`panel/banners/${id}`);
}

async function createBanner(banner) {
  return RestService.postAuthenticated('panel/banners/create', banner);
}

async function updateBanner(banner) {
  return RestService.putAuthenticated('panel/banners/update', banner);
}

async function deleteBanner(id) {
  return RestService.postAuthenticated('panel/banners/delete', { id });
}

async function uploadBanner(file, name, id) {
  const fd = new FormData();
  fd.append('file', file);
  return RestService.postAuthenticated(`panel/banners/import?&name=${name}&id=${id}`,
    fd, {
      'Content-Type': 'multipart/form-data',
    });
}

async function getCsvBannersReport() {
  const response = await RestService.getAuthenticated('panel/banners/report/csv', {
    responseType: 'blob',
  });
  const url = window.URL.createObjectURL(new Blob(['\ufeff', response]));
  const link = document.createElement('a');
  link.href = url;
  const filePath = 'banners-export.csv';
  link.setAttribute('download', filePath);
  document.body.appendChild(link);
  link.click();
}

async function getCsvBannerModel() {
  const response = await RestService.getAuthenticated('panel/banners/csv/model', {
    responseType: 'blob',
  });
  const url = window.URL.createObjectURL(new Blob(['\ufeff', response]));
  const link = document.createElement('a');
  link.href = url;
  const filePath = 'Modelo_Importação_Banners CSV.csv';
  link.setAttribute('download', filePath);
  document.body.appendChild(link);
  link.click();
}

async function uploadCsvBanners(file) {
  const fd = new FormData();
  fd.append('file', file);

  return RestService.postAuthenticated('panel/banners/import/csv', fd, {
    'Content-Type': 'multipart/form-data',
  });
}

async function getBannerImage(fileUrl) {
  // eslint-disable-next-line max-len
  const response = await RestService.getAuthenticatedBlob(`panel/banners/download/banner?imgLink=${fileUrl}`);
  const url = window.URL.createObjectURL(new Blob([response]));
  const link = document.createElement('a');
  link.href = url;
  const filePath = 'imagemBanner.jpg';
  link.setAttribute('download', filePath);
  document.body.appendChild(link);
  link.click();
}

export default {
  getBanners,
  getBanner,
  createBanner,
  updateBanner,
  uploadBanner,
  deleteBanner,
  getCsvBannersReport,
  getCsvBannerModel,
  uploadCsvBanners,
  getBannerImage,
};
